import { all, takeEvery } from 'redux-saga/effects'
import * as actions from './alerts.actions'

import { handleAddAlert } from './sagas/handle-add-alert'

export default function* () {
  yield all([takeEvery(actions.FETCH_ADD_ALERT, handleAddAlert)])
}
